module.exports = __webpack_public_path__ + "static/system-dla-agencji-reklamowej-280e0892ae5244d76471b7be3df1aa6a.jpg";